import { injectIntl } from 'react-intl';

import BreakdownFilter from './BreakdownFilter';

export default injectIntl(BreakdownFilter);
